import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Briefcase, Shield, Lock, Zap, Search, Globe, Users } from 'lucide-react';

export default function PricingEnterprise() {
  return (
    <SubpageTemplate 
      title="Enterprise"
      subtitle="Total Control"
      description="For organizations requiring absolute security, custom integrations, and dedicated synthesis infrastructure."
      icon={Shield}
      features={[
        {
          title: "Private Clusters",
          description: "Isolated inference engine instances for your organization's exclusive use.",
          icon: Lock
        },
        {
          title: "Audit Logs",
          description: "Comprehensive tracking of every build, deployment, and configuration change.",
          icon: Search
        },
        {
          title: "Dedicated Support",
          description: "24/7 technical support and a dedicated success engineer for your team.",
          icon: Users
        }
      ]}
    />
  );
}
